import { useIntl } from 'react-intl';

import { SubmitButton } from '@/components/signup/site-activation/components/common/submit-button';

export const JsmSubmitButtonNewUser = () => {
	const intl = useIntl();

	const submitMessage = intl.formatMessage(
		{
			id: 'bxpSignup.siteExpansion.goToProduct',
			defaultMessage: 'Go to {productName}',
		},
		{
			productName: 'Jira Service Management',
		},
	);

	return <SubmitButton submitMessage={submitMessage} />;
};
